// Hooks isolados pra página pública de convite: usam publicApi (sem
// interceptors/Authorization) via services/ResponsibleInvite/publicApi.
import { useMutation, useQuery } from 'react-query';
import { getPublicInviteInfoAsync, submitPublicInviteAsync } from '../../publicApi';
import type { IResponsibleInviteSubmitProps } from '../../types';

export const useGetPublicInviteInfoQuery = (token?: string) => {
  return useQuery(
    ['publicResponsibleInvite', token],
    async () => getPublicInviteInfoAsync(token as string),
    {
      enabled: !!token,
      retry: false,
      refetchOnWindowFocus: false,
    },
  );
};

export const useSubmitPublicInviteAsync = () => {
  return useMutation(
    ({ token, data }: { token: string; data: IResponsibleInviteSubmitProps }) =>
      submitPublicInviteAsync(token, data),
  );
};
